import axios from 'axios';
import env from './env';

// Create axios instance with base URL
const apiBaseUrl = env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Ensure base URL ends with /api but doesn't have double /api/
const normalizedBaseUrl = apiBaseUrl.replace(/\/api\/api$/, '/api').replace(/\/$/, '');

// Validate the base URL format
if (!normalizedBaseUrl.endsWith('/api')) {
    console.warn('API base URL should end with /api for consistency');
}

const instance = axios.create({
    baseURL: normalizedBaseUrl,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    timeout: parseInt(env.REACT_APP_API_TIMEOUT) || 30000, // Configurable timeout
});

// Add request interceptor to add auth token
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle errors
instance.interceptors.response.use(
    (response) => {
        // Log successful responses in development
        if (process.env.NODE_ENV === 'development') {
            console.debug('API Response:', response.config.url, response.status);
        }
        return response;
    },
    (error) => {
        // Log errors in development
        if (process.env.NODE_ENV === 'development') {
            console.error('API Error:', error.config?.url, error.response?.status, error.message);
        }

        if (error.response?.status === 401) {
            // Only redirect if not already on login page to prevent loops
            if (!window.location.pathname.includes('/login')) {
                localStorage.removeItem('auth_token');
                // Use React Router navigation instead of direct redirect when possible
                if (window.history && window.history.pushState) {
                    window.history.pushState(null, '', '/login');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                } else {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
